import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import ViewIcon from "../../../Assets/OptionsModel/View.svg";
import EditIcon from "../../../Assets/OptionsModel/edit.svg";
import DeleteIcon from "../../../Assets/OptionsModel/Delete.svg";
import { setModal, setSelectedSizeChart } from "../../../Features/inventoryManagementSlice";
function KebabMenu({ sizeChart, boxRef }) {
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const [visible, setVisible] = useState(false);

    const { kebabOpen } = useSelector((state) => state.inventoryManagement.sizeChartKebab);

    function handleViewProduct() {
        dispatch(setSelectedSizeChart(sizeChart));
        dispatch(setModal('view-size-chart'));
    }

    const handleEdit = () => {
        navigate(`edit-size-chart/${sizeChart.id}`)
    }

    function handleDelete(e) {
        e.stopPropagation();
        dispatch(setSelectedSizeChart(sizeChart));
        dispatch(setModal('delete-size-chart'));
    }

    useEffect(() => {
        if(kebabOpen) {
            setVisible(true);
        } else {
            setVisible(false);
        }
    }, [kebabOpen]);

    return (
        <div ref={boxRef} className={`${visible ? 'opacity-100 visible' : 'opacity-0 invisible'} transition-all duration-150 ease-in-out bg-[#FFFFFF] absolute z-20 w-32 top-0 right-6 flex flex-col gap-0 shadow-[0px_0px_12px_0px_#0000003D] rounded-md overflow-hidden`}>
            <button onClick={handleViewProduct} className='w-full select-none flex items-center gap-[6px] px-2 py-[10px] rounded hover:bg-[#F5F5F5]'>
                <div className="size-[18px] flex items-center justify-center">
                    <img src={ViewIcon} alt="" />
                </div>

                <p className='font-medium text-[14px] leading-5 text-[#121212]'>View</p>
            </button>

            <button onClick={handleEdit} className='w-full select-none flex items-center gap-[6px] px-2 py-[10px] rounded hover:bg-[#F5F5F5]'>
                <div className="size-[18px] flex items-center justify-center">
                    <img src={EditIcon} alt="" />
                </div>

                <p className='font-medium text-[14px] leading-5 text-[#121212]'>Edit</p>
            </button>

            <button onClick={handleDelete} className='w-full select-none flex items-center gap-[6px] px-2 py-[10px] rounded hover:bg-[#F5F5F5]'>
                <div className="size-[18px] flex items-center justify-center">
                    <img src={DeleteIcon} alt="" />
                </div>

                <p className='font-medium text-[14px] leading-5 text-[#121212]'>Delete</p>
            </button>
        </div>
    )
}

export default KebabMenu;
